import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import DiasporaPage from "@/pages/DiasporaPage";
import PackagesPage from "@/pages/PackagesPage";
import PropertyGuidePage from "@/pages/PropertyGuidePage";
import SafePropertyGuidePage from "@/pages/SafePropertyGuidePage";
import DiasporaLegalGuidePage from "@/pages/DiasporaLegalGuidePage";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/diaspora" element={<DiasporaPage />} />
          <Route path="/packages" element={<PackagesPage />} />
          <Route path="/guide/buying-property-nigeria" element={<PropertyGuidePage />} />
          <Route path="/guide/safe-property-buying" element={<SafePropertyGuidePage />} />
          <Route path="/insights/diaspora-property-guide" element={<DiasporaLegalGuidePage />} />
        </Routes>
      </BrowserRouter>
      <FloatingWhatsApp />
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
